export default function ClarksvilleTestimonialsSection() {
  const testimonials = [
    {
      name: "SSG Michael Torres",
      title: "101st Airborne Division",
      initials: "MT",
      text: "Got my deployment orders on a Thursday. By Friday afternoon I had my passport in hand. These guys understand military timelines better than anyone. No hassle, no \"come back in 6 weeks\" nonsense.",
      date: "Verified Review",
    },
    {
      name: "Jennifer Hollis",
      title: "Military Spouse, Fort Campbell",
      initials: "JH",
      text: "My husband was deploying and we realized our kids' passports were expired. They handled all three kids' passports in two days. The family discount made a real difference too. Highly recommend!",
      date: "Verified Review",
    },
    {
      name: "Emily Park",
      title: "APSU Study Abroad Student",
      initials: "EP",
      text: "I thought I missed the deadline for my semester in Seoul. Called these guys on a Monday, had my passport by Wednesday. I made it on time and it was the best experience of my life. Thank you!",
      date: "Verified Review",
    },
    {
      name: "CW3 David Kowalski",
      title: "160th SOAR, Fort Campbell",
      initials: "DK",
      text: "The team here knows exactly what military personnel need. They handled my emergency passport for a classified TDY with complete discretion and total professionalism. I've sent my whole unit here.",
      date: "Verified Review",
    },
    {
      name: "Priya Sharma",
      title: "Clarksville Resident",
      initials: "PS",
      text: "Renewed my family's three passports in 72 hours. The communication was excellent — text updates every step of the way. The staff genuinely care about their community. Will never use anyone else.",
      date: "Verified Review",
    },
    {
      name: "Tony Weston",
      title: "DoD Contractor, Fort Campbell",
      initials: "TW",
      text: "Third time using this service. As a DoD contractor I need passports renewed on a tight schedule. They've never missed a deadline. Fast, accurate, and worth every penny.",
      date: "Verified Review",
    },
  ];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Testimonials</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Trusted by Fort Campbell Families
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real stories from soldiers, military spouses, and Clarksville residents who trusted us with their most important travel document.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div key={index} className="bg-[#F7F8FA] rounded-xl p-7 hover:bg-[#EEF2F8] transition-all">
              <div className="flex items-center mb-2">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] text-white text-sm font-bold flex-shrink-0">
                  {t.initials}
                </div>
                <div>
                  <div className="font-semibold text-[#1A365D] text-sm">{t.name}</div>
                  <div className="text-gray-400 text-xs">{t.title}</div>
                </div>
                <div className="ml-auto">
                  <span className="bg-[#EEF2F8] text-[#1A365D] text-xs px-2 py-1 rounded-full whitespace-nowrap">{t.date}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}